<template>
    <div id="visitor-detail">
        <a-spin :spinning="loading">
            <div class="detail-head">
                <div class="visitor-merge-bar" v-if="otherVisitors.length > 1">
                    <span class="visitor-merge-left">
                        <span class="visitor-merge-title">{{ otherVisitors.length }} similar profiles found</span>
                        <span
                            class="visitor-merge-item"
                            v-for="(otherVisitor, index) in otherVisitors"
                            @click="getVisitorInfo(otherVisitor._id)"
                            :class="selectedMergeVisitorId === otherVisitor._id ? 'other-visitor-selected' : ''"
                            >{{ otherVisitors.length < 8 ? `Profile #${index + 1}` : `#${index + 1}` }}</span
                        >
                    </span>
                    <span class="visitor-merge-right" @click="mergeVisitors()">
                        <span class="material-icons" style="font-size: 22px; color: black">auto_fix_high</span>
                        <span class="visitor-merge-name">Merge {{ otherVisitors.length }} profiles</span>
                    </span>
                </div>
                <div class="head-color"></div>
                <div class="header-wrapper">
                    <span class="user-segment-avatar text-center">
                        <md-highlight-text md-term="term" class="text-center">
                            {{ !!visitor.fullname ? visitor.fullname.substr(0, 1).toUpperCase() : "V" }}
                        </md-highlight-text>
                    </span>
                    <div class="user-details">
                        <div class="username-detail">
                            <div class="user-name">
                                {{ visitor.fullname ? visitor.fullname : "Visitor" }}
                            </div>
                            <a-popover
                                v-if="checkPermission(PERMISSION_TYPES['visitor.view'].tr.name)"
                                placement="bottom"
                                trigger="focus"
                                class="visitor-popover story-menu-content px-3"
                            >
                                <div slot="content" class="delete-user">
                                    <span> <a-icon type="close-circle-o" class="px-1" /></span>
                                    <span
                                        @click="deleteUserVisible = true"
                                        v-if="checkPermission(PERMISSION_TYPES['visitor.delete'].tr.name)"
                                        >{{ $t("visitor.deleteUser") }}</span
                                    >
                                </div>
                                <div slot="content" class="ban-user">
                                    <span> <a-icon type="stop-o" class="px-1" /></span>
                                    <span
                                        v-if="
                                            !visitorBanned && checkPermission(PERMISSION_TYPES['visitor.block'].tr.name)
                                        "
                                        @click="ban()"
                                        >Block User</span
                                    >
                                    <span
                                        v-else-if="checkPermission(PERMISSION_TYPES['visitor.unblock'].tr.name)"
                                        @click="unban()"
                                    >
                                        UnBlock User
                                    </span>
                                </div>
                                <div slot="content" class="wa-business-chat" v-if="isWABusiness()">
                                    <span> <a-icon type="play-circle" class="px-1" /></span>
                                    <span @click="ban()">Start Chat</span>
                                </div>
                                <div slot="content" class="wa-business-chat" v-if="isWhatsappV1()">
                                    <span> <a-icon type="play-circle" class="px-1" /></span>
                                    <span @click="ban()">Start Chat</span>
                                </div>
                                <div slot="content" class="wa-business-chat" v-if="isWhatsappV2()">
                                    <span> <a-icon type="play-circle" class="px-1" /></span>
                                    <span @click="ban()">Start Chat</span>
                                </div>
                                <a-button
                                    style="margin-left: auto; font-weight: bolder; letter-spacing: 2px; font-size: 20px"
                                    @click="(e) => e.stopPropagation()"
                                >
                                    ...
                                </a-button>
                            </a-popover>
                            <div
                                class="visitor-actions"
                                style="display: none; justify-content: center; align-items: center"
                            >
                                <a-button
                                    class="classic-button"
                                    style="margin-right: 3px"
                                    size="small"
                                    @click="deleteUserVisible = true"
                                    v-if="checkPermission(PERMISSION_TYPES['visitor.delete'].tr.name)"
                                >
                                    <span style="margin-right: 3px; display: block; font-size: 12px"
                                        ><a-icon type="close-circle-o" class="px-1" /> Delete User</span
                                    >
                                </a-button>
                                <a-button
                                    class="classic-button"
                                    style="margin-right: 3px"
                                    size="small"
                                    v-if="!visitorBanned && checkPermission(PERMISSION_TYPES['visitor.block'].tr.name)"
                                    @click="ban()"
                                >
                                    <span style="margin-right: 3px; display: block; font-size: 12px">
                                        <a-icon type="stop-o" class="px-1" /> Block</span
                                    >
                                </a-button>
                                <a-button
                                    class="classic-button"
                                    style="margin-right: 3px"
                                    size="small"
                                    v-else-if="checkPermission(PERMISSION_TYPES['visitor.unblock'].tr.name)"
                                    @click="unban()"
                                >
                                    <span style="margin-right: 3px; display: block; font-size: 12px">
                                        <a-icon type="stop-o" class="px-1" /> UnBlock
                                    </span>
                                </a-button>

                                <a-button
                                    class="classic-button"
                                    style="margin-right: 3px"
                                    size="small"
                                    v-if="isWABusiness()"
                                    @click="startWhatsappChat()"
                                >
                                    <span style="margin-right: 3px; display: block; font-size: 12px">
                                        <a-icon type="play-circle" class="px-1" /> Start Chat</span
                                    >
                                </a-button>
                                <a-button
                                    class="classic-button"
                                    style="margin-right: 3px"
                                    size="small"
                                    v-if="isWhatsappV1()"
                                    @click="startWhatsappChat()"
                                >
                                    <span style="margin-right: 3px; display: block; font-size: 12px">
                                        <a-icon type="play-circle" class="px-1" /> Start Chat</span
                                    >
                                </a-button>
                                <a-button
                                    class="classic-button"
                                    style="margin-right: 3px"
                                    size="small"
                                    v-if="isWhatsappV2()"
                                    @click="startWhatsappChat()"
                                >
                                    <span style="margin-right: 3px; display: block; font-size: 12px">
                                        <a-icon type="play-circle" class="px-1" /> Start Chat</span
                                    >
                                </a-button>
                            </div>
                        </div>

                        <div class="user-email" style="display: flex; align-items: center">
                            <span>
                                {{ visitor.email ? visitor.email : $t("visitor.noEmail") }}
                            </span>
                            <span v-if="!!visitor.emailVerified" class="material-icons mail-check">verified_user</span>
                            <span v-else class="mail-close">(not verified)</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="detail-body">
                <div class="supsis-tab-selection">
                    <div
                        class="supsis-tab-selection-item"
                        :class="[tabKey == 'visitor-details' && 'selected']"
                        @click="changeTabKey('visitor-details')"
                    >
                        {{ $t("message.profile") }}
                    </div>
                    <div
                        class="supsis-tab-selection-item"
                        :class="[tabKey == 'visitor-notes' && 'selected']"
                        @click="changeTabKey('visitor-notes')"
                    >
                        {{ $t("message.notes") }}
                    </div>
                    <div
                        class="supsis-tab-selection-item"
                        :class="[tabKey == 'visitor-activities' && 'selected']"
                        @click="changeTabKey('visitor-activities')"
                    >
                        {{ $t("wp.actions") }}
                    </div>
                    <div
                        class="supsis-tab-selection-item"
                        :class="[tabKey == 'visitor-chats' && 'selected']"
                        @click="changeTabKey('visitor-chats')"
                    >
                        {{ $t("message.conversationHistory") }}
                    </div>
                    <div
                        class="supsis-tab-selection-item"
                        :class="[tabKey == 'visitor-mails' && 'selected']"
                        @click="changeTabKey('visitor-mails')"
                    >
                        Kullanıcı Mailleri
                    </div>
                </div>
                <div v-if="tabKey == 'visitor-details'">
                    <div style="width: 100%" class="mt-4">
                        <div class="segments">
                            <span class="material-icons" style="font-size: 20px"> group </span>
                            <span class="segment-user"> Tercih Edilen Temsilciler </span>
                        </div>
                        <div class="row ml-sm-n1">
                            <PreferredAgents
                                v-if="visitor"
                                :visitorId="visitor._id"
                                v-model="visitor.preferredAgents"
                            />
                        </div>
                    </div>
                    <div style="width: 100%" class="mt-4">
                        <div class="segments">
                            <span class="material-icons" style="font-size: 20px"> pie_chart </span>
                            <span class="segment-user"> {{ $t("visitor.tags") }} </span>
                        </div>
                        <div class="row ml-sm-n1">
                            <span class="select-segment" v-for="(selectTag, index) in selectedTagsList">
                                <span class="material-icons closeIcon" @click="tagRemove(selectTag._id, index)">
                                    close
                                </span>
                                <span class="select-segment-text">{{ selectTag.name }}</span>
                            </span>
                            <span>
                                <a-button @click="tagModalVisible = true" class="add-segment">
                                    <span class="material-icons" style="font-size: 25px">add</span>
                                    <span class="last-session-data">{{ $t("visitor.addTag") }}</span>
                                </a-button>
                            </span>
                        </div>
                    </div>
                    <div style="width: 100%" class="mt-4">
                        <div class="segments">
                            <span class="material-icons" style="font-size: 20px"> pie_chart </span>
                            <span class="segment-user"> {{ $t("visitor.segments") }} </span>
                        </div>
                        <div class="row ml-sm-n1">
                            <span class="select-segment" v-for="(selectSegment, index) in selectedSegmentsList">
                                <span class="material-icons closeIcon" @click="segmentRemove(selectSegment._id, index)">
                                    close
                                </span>
                                <span class="select-segment-text">{{ selectSegment.name }}</span>
                            </span>
                            <span>
                                <a-button @click="segmentModalVisible = true" class="add-segment">
                                    <span class="material-icons" style="font-size: 25px">add</span>
                                    <span class="last-session-data">{{ $t("visitor.addSegment") }}</span>
                                </a-button>
                            </span>
                        </div>
                    </div>
                    <div class="mt-4">
                        <VisitorAttributes :visitor="visitor" />
                    </div>
                </div>
                <div v-if="tabKey === 'visitor-notes'">
                    <div style="width: 100%; margin-top: 40px">
                        <div class="segments" style="justify-content: space-between">
                            <span>
                                <span class="material-icons" style="font-size: 20px"> query_builder </span>
                                <span class="segment-user"> Notes </span>
                            </span>
                        </div>

                        <VisitorNotes :notes="notes" />
                    </div>
                </div>
                <div class="row" v-if="tabKey === 'visitor-activities'">
                    <div class="col-12 col-md-6">
                        <div style="width: 100%; margin-top: 40px">
                            <div class="user-data">
                                <span class="material-icons"> account_circle </span>
                                <span class="segment-user"> Ziyaretçi Web Gezintisi </span>
                            </div>
                            <VisitorActivities :activities="activities" :type="'connect_log'" />
                        </div>
                    </div>
                    <div class="col-12 col-md-6">
                        <div style="width: 100%; margin-top: 40px">
                            <div class="user-data">
                                <span class="material-icons"> account_circle </span>
                                <span class="segment-user">Ziyaretçi Haraketleri </span>
                            </div>
                            <VisitorActivities :activities="activities" />
                        </div>
                    </div>
                </div>
                <div v-if="tabKey === 'visitor-chats'">
                    <div style="width: 100%; margin-top: 40px">
                        <div class="segments" style="justify-content: space-between">
                            <span>
                                <span class="material-icons" style="font-size: 20px"> query_builder </span>
                                <span class="segment-user"> {{ $t("visitor.userChats") }} </span>
                            </span>
                            <div>
                                <a-button @click="seeAll" class="add-segment">
                                    <span class="material-icons" style="font-size: 18px; margin-right: 5px"
                                        >visibility</span
                                    >
                                    <span class="last-session-data">{{ $t("visitor.seeAll") }}</span>
                                </a-button>
                            </div>
                        </div>

                        <VisitorChatList :visitor-id="cloneVisitorId" @detailClose="closeModal" />
                    </div>
                </div>
                <div v-if="tabKey === 'visitor-mails'">
                    <div style="width: 100%; margin-top: 10px">
                        <div class="segments" style="justify-content: space-between">
                            <span>
                                <span class="material-icons" style="font-size: 20px"> query_builder </span>
                                <span class="segment-user"> {{ $t("visitor.userMails") }} </span>
                            </span>
                        </div>

                        <VisitorMailList :visitorMail="visitor.email" :isGetChat="visibleMail" :visitorId="visitorId" />
                    </div>
                </div>
            </div>
            <a-modal
                id="add-to-segment"
                :title="$t('visitor.addSegment')"
                v-model="segmentModalVisible"
                :footer="null"
                v-if="segmentModalVisible"
            >
                <div class="add-segment-search">
                    <input
                        :placeholder="$t('visitor.filterName')"
                        style="border: none"
                        v-model="segmentSearch"
                        @input="segmentSearchChange"
                    />
                    <span class="material-icons mx-2 add-segment-search-icon"> search </span>
                </div>
                <VisitorAddSegment
                    v-for="filterSegment in filterSegments"
                    :key="filterSegment._id"
                    :row="filterSegment"
                    :on-select-changed="() => segmentSelectChanged(filterSegment)"
                    :selectedSegments="selectedSegmentsList"
                />
                <div style="display: flex; justify-content: space-between; margin-top: 30px">
                    <a-button
                        class="add-segment-setting-btn"
                        @click="() => this.$router.push(`/chatbot/user-segments`)"
                    >
                        <span class="material-icons mr-2" style="font-size: 20px"> settings </span>
                        <span>{{ $t("visitor.manageSegments") }}</span>
                    </a-button>
                    <a-button class="add-segment-confirm-btn" @click="segmentHandleCancel">
                        {{ $t("visitor.confirm") }}
                    </a-button>
                </div>
            </a-modal>
            <a-modal
                id="add-to-tag"
                :title="$t('visitor.addTag')"
                v-model="tagModalVisible"
                :footer="null"
                v-if="tagModalVisible"
            >
                <div class="add-segment-search">
                    <input
                        :placeholder="$t('visitor.filterName')"
                        style="border: none"
                        v-model="tagSearch"
                        @input="tagSearchChange"
                    />
                    <span class="material-icons mx-2 add-segment-search-icon"> search </span>
                </div>
                <VisitorAddSegment
                    v-for="filterTag in getFilteredTags()"
                    :key="filterTag._id"
                    :row="filterTag"
                    :on-select-changed="() => tagSelectChanged(filterTag)"
                    :selectedSegments="selectedTagsList"
                />
                <div style="display: flex; justify-content: space-between; margin-top: 30px">
                    <a-button class="manage-tags-btn" @click="() => this.$router.push(`/tags`)">
                        <span class="material-icons mr-2" style="font-size: 20px"> settings </span>
                        <span>{{ $t("visitor.manageTags") }}</span>
                    </a-button>
                    <a-button class="add-segment-confirm-btn" @click="tagHandleCancel">
                        {{ $t("visitor.confirm") }}
                    </a-button>
                </div>
            </a-modal>
            <a-modal
                id="delete-user-modal"
                :title="$t('visitor.deleteUser')"
                v-model="deleteUserVisible"
                v-if="deleteUserVisible"
                centered
                @ok="() => deleteUser()"
            >
                <div class="delete-user-modal-message">
                    {{ $t("message.deleteVisitor") }}
                </div>
            </a-modal>
        </a-spin>
    </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from "vuex";
import { log2 } from "../../../utils/log2";
import VisitorChatList from "../Visitors/VisitorChatList";
import VisitorMailList from "../Visitors/VisitorMailList";
import VisitorNotes from "../Visitors/VisitorNotes.vue";
import VisitorAttributes from "../Visitors/VisitorAttributes.vue";
import VisitorAddSegment from "../Visitors/VisitorAddSegment";
import VisitorActivities from "../Visitors/VisitorActivities";
import { sendSocketMessage, socketMessageStream } from "../../../utils/socketStream";
import router from "../../../router";
import { PERMISSION_TYPES } from "../../../language/permissionTypes";
import * as _ from "lodash";
import SYSTEM_PUBSUB from "../../../utils/systemPubSub";
import { filter, first, timeout } from "rxjs/operators";
import PreferredAgents from "../../../components/PreferredAgents";

const log = log2("VisitorDetailComponent");
export default {
    name: "VisitorDetailComponent",
    components: {
        VisitorChatList,
        VisitorMailList,
        VisitorAttributes,
        VisitorAddSegment,
        VisitorNotes,
        VisitorActivities,
        PreferredAgents,
    },
    props: {
        visitorId: {
            type: String,
            default: "",
        },
        visibleMail: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            visitor: {},
            segmentModalVisible: false,
            tagModalVisible: false,
            deleteUserVisible: false,
            segments: null,
            segmentSearch: "",
            tagSearch: "",
            filterSegments: null,
            filteredTags: [],
            hovered: false,
            selectSegments: [],
            selectTags: [],
            selectedSegmentsList: [],
            selectedTagsList: [],
            notes: [],
            activities: [],
            visitorBanned: false,
            tabKey: "",
            mapUsers: {},
            preferredAgentsModal: false,
            cloneVisitorId: this.$route.params.visitorId,
            otherVisitors: [],
            selectedMergeVisitorId: "",
            loading: false,
        };
    },
    async mounted() {
        console.log("mounted this.visitorId", this.visitorId);
        this.selectedMergeVisitorId = this.visitorId || this.cloneVisitorId;
        this.otherVisitors = await this.getOtherProfiles(this.cloneVisitorId || this.visitorId);
        this.tabKey = !!this.visibleMail ? "visitor-mails" : "visitor-details";
        if (this.visitorId) this.cloneVisitorId = this.visitorId;
        await this.fetch();
        this.listSegments()
            .then((res) => {
                console.log("mounted segments", res);
                this.segments = res || [];
                this.filterSegments = res || [];
                const selectedSeg = res.filter((x) => {
                    const qwe = x.users.filter((user) => {
                        return user === this.visitor._id;
                    });
                    return qwe.length > 0;
                });
                this.selectedSegmentsList = selectedSeg || [];
                this.selectSegments = selectedSeg || [];
            })
            .finally(() => {});
        const notes = await this.getNotes(this.visitor._id);
        this.notes = notes;
        this.activities = await this.getVisitorActivity(this.visitor._id);
        this.filteredTags = this.tags || [];
        this.selectedTagsList = this.visitor.tags || [];
        this.selectTags = this.visitor.tags || [];
        this.mapUsers = this.users.reduce((acc, user) => {
            acc[user._id] = user;
            return acc;
        }, {});
    },
    computed: {
        PERMISSION_TYPES() {
            return PERMISSION_TYPES;
        },
        ...mapGetters({
            checkPermission: "auth/checkPermission",
            myActiveConversations: "chat/getMyActiveConversations",
        }),
        ...mapState({
            tags: (state) => state.tag.tags.data,
            user: (state) => state.auth.user,
            users: (state) => state.user.users.data,
            site: (state) => state.site.site,
            isAdmin: (state) => state.auth.adminUser != null,
            conversations: (state) => state.chat.conversations,
            channels: (state) => state.channel.channels,
        }),
    },
    methods: {
        ...mapActions({
            updateTags: "chat/updateTags",
            getVisitor: "visitor/getVisitor",
            updateTagVisitor: "visitor/updateTagVisitor",
            deleteTagVisitor: "visitor/deleteTagVisitor",
            getTags: "tag/getTags",
            deleteVisitor: "visitor/deleteVisitor",
            listSegments: "CB/listSegments",
            addUserToSegment: "CB/addUserToSegment",
            deleteSegment: "CB/deleteSegment",
            banVisitor: "visitor/banVisitor",
            unbanVisitor: "visitor/unbanVisitor",
            getNotes: "visitor/getNotes",
            getVisitorActivity: "visitor/getVisitorActivity",
            updatePreferredAgents: "visitor/updatePreferredAgents",
            getOtherProfiles: "visitor/getOtherProfiles",
            mergeVisitorsAction: "visitor/mergeVisitors",
        }),
        async getVisitorInfo(visitorId) {
            console.log("getVisitorInfo visitorId", visitorId);
            this.selectedMergeVisitorId = visitorId;
            await this.fetch(visitorId);
            const selectedSeg = this.segments.filter((x) => {
                const qwe = x.users.filter((user) => {
                    return user === this.visitor._id;
                });
                return qwe.length > 0;
            });
            this.selectedSegmentsList = selectedSeg || [];
            this.selectSegments = selectedSeg || [];
        },
        async mergeVisitors() {
            this.loading = true;
            console.log("mergeVisitors datas", {
                selectedMergeVisitorId: this.selectedMergeVisitorId,
                otherVisitors: this.otherVisitors,
            });
            const otherVisitors = this.otherVisitors.filter((x) => x._id !== this.selectedMergeVisitorId);
            await this.mergeVisitorsAction({
                selectedMergeVisitorId: this.selectedMergeVisitorId,
                otherVisitors: otherVisitors,
            }).then(async (res) => {
                console.log("mergeVisitors result", res);
                this.$message.success("Merge işlemi başarıyla gerçekleştirildi.");
                this.otherVisitors = [];
                await this.fetch();
                const selectedSeg = this.segments.filter((x) => {
                    const qwe = x.users.filter((user) => {
                        return user === this.visitor._id;
                    });
                    return qwe.length > 0;
                });
                this.selectedSegmentsList = selectedSeg || [];
                this.selectSegments = selectedSeg || [];
                this.loading = false;
            });
        },
        closeModal() {
            this.$emit("detailClose");
        },

        changeTabKey(key) {
            this.tabKey = key;
        },
        isWABusiness() {
            const channelId = _.get(this.visitor, "channel");
            const channel = this.channels.find((c) => c._id === channelId);
            return _.get(channel, "type") === "whatsapp-business-api";
        },
        isWhatsappV1() {
            const channelId = _.get(this.visitor, "channel");
            const channel = this.channels.find((c) => c._id === channelId);
            return _.get(channel, "type") === "whatsapp-v1" || _.get(channel, "type") === "whatsapp-qr";
        },
        isWhatsappV2() {
            const channelId = _.get(this.visitor, "channel");
            const channel = this.channels.find((c) => c._id === channelId);
            return _.get(channel, "type") === "whatsapp-v2";
        },
        startWhatsappChat() {
            const channelId = _.get(this.visitor, "channel");
            const whatsappNumber = _.get(this.visitor, "whatsappNumber");
            if (!whatsappNumber) return;
            if (!channelId) return;
            log("startChat", { whatsappNumber, channelId });
            const maybeJoinedChat = this.myActiveConversations.find(
                (x) => x.whatsappNumber === whatsappNumber + "@c.us" || x.whatsappNumber === whatsappNumber
            );
            if (!!maybeJoinedChat) {
                SYSTEM_PUBSUB.publish(SYSTEM_PUBSUB.MESSAGE_TYPES.FOCUS_CHAT, {
                    conversationId: maybeJoinedChat._id,
                });
            } else {
                const hide = this.$message.loading(this.$t("wp.chatStartingWait"), 0);

                socketMessageStream
                    .pipe(
                        filter((x) => x.cmd === "join_chat_immediately"),
                        timeout(5000),
                        first()
                    )
                    .toPromise()
                    .then((x) => {
                        this.$message.success(this.$t("wp.chatStarted"));
                    })
                    .catch((err) => {
                        this.$message.error(this.$t("wp.chatNotStarted"));
                    })
                    .finally(() => {
                        hide();
                    });
                sendSocketMessage("user start-chat", {
                    siteId: this.site._id,
                    userId: this.user._id,
                    whatsappNumber: whatsappNumber,
                    channelId: channelId,
                });
            }
        },
        segmentSearchChange(e) {
            this.filterSegments = this.segments.filter((segment) => {
                return segment.name.match(new RegExp(this.segmentSearch, "gmi"));
            });
        },
        getFilteredTags() {
            if ((this.tagSearch || "").trim().length > 0) {
                return this.tags.filter((tag) => {
                    return tag.name.match(new RegExp(this.tagSearch, "gmi"));
                });
            } else {
                return this.tags;
            }
        },
        tagSearchChange(e) {},
        segmentRemove(segmentId, index) {
            this.selectedSegmentsList.splice(index, 1);
            this.deleteSegment({ segmentId: segmentId, userId: this.visitor._id })
                .then((res) => {})
                .finally(() => {});
        },
        async tagRemove(tagId, index) {
            this.selectedTagsList.splice(index, 1);
        },
        segmentSelectChanged(row) {
            const findIndex = this.selectSegments.findIndex((x) => x._id === row._id);
            if (findIndex < 0) {
                this.selectSegments = [...this.selectSegments, row];
            } else {
                this.selectSegments.splice(findIndex, 1);
            }
        },
        ban() {
            const socketMessageId = this.isAdmin ? "admin visitor_block" : "user visitor-block";
            const conversation = this.conversations.find((x) => x.visitor._id === this.visitor._id);
            sendSocketMessage(socketMessageId, {
                visitorId: this.visitor._id,
                userId: this.user._id,
                siteId: this.site._id,
                conversationId: conversation ? conversation._id : null,
            });
            this.banVisitor(this.visitor._id);
            this.visitorBanned = true;
        },
        unban() {
            const socketMessageId = this.isAdmin ? "admin visitor_unblock" : "user visitor-unblock";
            sendSocketMessage(socketMessageId, {
                visitorId: this.visitor._id,
                siteId: this.site._id,
            });
            this.unbanVisitor(this.visitor._id);
            this.visitorBanned = false;
        },
        // tün seçimlerde liste düzenlenir
        tagSelectChanged(row) {
            log("tagSelectChanged this.selectTags --", this.selectTags);
            const findIndex = this.selectTags.findIndex((x) => x._id === row._id);
            if (findIndex < 0) {
                this.selectTags = [...this.selectTags, row];
            } else {
                this.selectTags.splice(findIndex, 1);
            }
        },
        // düzenlenen liste en son kaydedilmek üzere selectedSegmentsList değişkenine atılır
        segmentHandleCancel() {
            this.selectedSegmentsList = this.selectSegments || [];
            this.segmentSearch = "";
            this.segmentModalVisible = false;
            this.filterSegments = this.segments || [];
        },
        tagHandleCancel() {
            this.selectedTagsList = this.selectTags || [];
            this.tagSearch = "";
            this.tagModalVisible = false;
            this.filteredTags = this.tags || [];
        },
        showMessage(level, message, key = Math.random(), duration = 4) {
            this.$message[level]({
                content: message,
                key,
                duration,
            });
        },
        async deleteUser() {
            const result = await this.deleteVisitor(this.visitor._id);
            if (result.data === true) {
                this.$router.push(`/visitors/`);
                this.showMessage("success", `Ziyaretçi silme işlemi başarılı.`);
            }
        },
        async fetch(visitorId) {
            this.loading = true;
            console.log("fetch visitorId", { visitorId, cloneVisitorId: this.cloneVisitorId });
            await this.getVisitor(visitorId || this.cloneVisitorId).then((response) => {
                console.log("fetch response", response);
                this.visitor = response.data;
                this.selectedTagsList = this.visitor.tags || [];
                this.visitorBanned = this.visitor.isBlocked;
                this.selectTags = this.visitor.tags || [];
                console.log("fetch this.segments", this.segments);
                this.loading = false;
            });
        },
        seeAll() {
            this.$router.push(`/archives/${this.visitor._id}?allTime=1`);
        },
    },
    beforeMount() {
        if (this.checkPermission(PERMISSION_TYPES["visitor.view"].tr.name) === false) {
            return router.push("/denied");
        }
    },
    watch: {
        selectedSegmentsList(newValue) {
            this.listSegments()
                .then((listSegments) => {
                    const selectedSeg = listSegments.filter((x) => {
                        const qwe = x.users.filter((user) => {
                            return user === this.visitor._id;
                        });
                        return qwe.length > 0;
                    });
                    newValue.map((x) => {
                        const index = selectedSeg.findIndex((y, index) => {
                            return y._id === x.id;
                        });
                        if (index < 0) {
                            const segmentId = typeof x === "object" ? x._id : x;
                            this.addUserToSegment({ segmentId, userId: this.visitor._id })
                                .then((res) => {})
                                .finally(() => {});
                        } else {
                            selectedSeg.splice(index, 1);
                        }
                    });
                    selectedSeg.map((x) => {
                        this.deleteSegment({ segmentId: x._id, userId: this.visitor._id })
                            .then((res) => {})
                            .finally(() => {});
                    });
                })
                .finally(() => {});
        },
        selectedTagsList(newValue) {
            const tagsId = newValue.map((x) => x._id);
            this.updateTagVisitor({ visitorId: this.visitor._id, tagIds: tagsId });
        },
    },
};
</script>

<style lang="scss">
@media only screen and (min-width: 768px) {
    #visitor-detail {
        .visitor-actions {
            display: flex !important;
        }

        .visitor-popover {
            display: none !important;
        }
    }
}

#add-to-segment {
    .add-segment-search {
        border: 1px solid #c6cdd4;
        padding: 7px;
        border-radius: 7px;
        display: flex;
        justify-content: space-between;
        margin-bottom: 10px;

        &:focus {
            border-color: #006cff;

            .add-segment-search-icon {
                color: #006cff;
            }
        }
    }

    .add-segment-setting-btn {
        display: flex !important;
        justify-content: center;
        align-content: center;
        background: #006cff;
        border: 1px solid #006cff;
        color: #fff;
        align-items: center;
        margin-left: 10px;
    }

    .add-segment-confirm-btn {
        background: #006cff;
        border: 1px solid #006cff;
        color: #fff;
    }
}

.manage-tags-btn {
    display: flex !important;
    justify-content: center !important;
    align-content: center !important;
    align-items: center !important;
    margin-left: 10px !important;
}

.ant-popover-inner-content {
    .delete-user {
        cursor: pointer;

        &:hover {
            color: #006cff;
        }
    }
}

#visitor-detail {
    background-color: #ffffff;
    height: 100%;
    width: calc(100vw - 80px); // bu kısımda 80px verilmesinin sebebi içerdeki

    .supsis-tab-selection {
        width: 100%;
        border-bottom: 1px solid #d9d9d9;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        overflow: auto;
        width: calc(100vw - 200px);
        cursor: pointer;

        &-item {
            background: white;
            color: black;
            border: 1px solid #d9d9d9;
            border-bottom: none;
            padding: 10px 0px;
            border-radius: 3px 3px 0px 0px;
            margin-right: 4px;
            min-width: 180px;
            display: flex;
            align-items: center;
            justify-content: center;

            &.selected {
                background: #ffa800;
                color: white;
                border: 1px solid #ffa800;
                font-weight: 500;
            }
        }
    }

    .add-segment {
        display: flex;
        align-items: center;
        margin-top: 5px;
    }

    .detail-head {
        width: 100%;

        .visitor-merge-bar {
            background-color: black;
            color: white;
            display: flex;
            justify-content: space-between;
            padding: 15px;
            font-weight: 700;
            font-size: 15px;

            .visitor-merge-left {
                display: flex;
                align-items: center;
                justify-content: center;

                .visitor-merge-item {
                    background-color: grey;
                    padding: 5px;
                    border-radius: 5px;
                    cursor: pointer;

                    &.other-visitor-selected {
                        background-color: #ffa800;
                    }
                }

                .visitor-merge-title {
                    margin-right: 20px;
                }
            }

            .visitor-merge-right {
                display: flex;
                align-items: center;
                justify-content: center;
                background-color: white;
                color: black;
                padding: 5px;
                border-radius: 5px;
                cursor: pointer;

                .visitor-merge-name {
                    margin-left: 10px;
                }
            }
        }

        .header-wrapper {
            display: flex;
            align-items: bottom;
            width: 100%;

            .user-details {
                width: calc(100% - 200px);
                margin-top: 10px;

                .username-detail {
                    display: flex;
                    align-items: center;
                }

                .user-name {
                    color: #22272d;
                    font-weight: bold;
                    font-size: 22px;
                    width: calc(100% - 100px);
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    display: block;
                }

                .user-email {
                    font-size: 16px;

                    .mail-check {
                        color: green;
                        margin-left: 5px;
                        font-weight: 800;
                        font-size: 20px;
                    }

                    .mail-close {
                        color: red;
                        margin-left: 5px;
                        font-weight: 800;
                        font-size: 13px;
                    }
                }
            }
        }

        .actions {
            padding: 5px;

            .classic-button {
                border: none;
                background-color: #ffa80040;
                color: #ffa800;
                font-family: Poppins;
                font-weight: 600 !important;
                font-size: 14px;
                cursor: pointer;
                padding: 3px 10px;
                border-radius: 6px;
                display: flex;
                justify-content: center;
                align-items: center;

                &.visitor-attr {
                    font-size: 12px !important;
                    padding: 1px 10px !important;
                    font-weight: 400 !important;
                }

                &.open-note {
                    padding: 3px !important;
                    margin-right: 5px;

                    span.material-icons {
                        font-size: 16px !important;
                    }
                }
            }
        }
    }

    .head-color {
        background-color: #fff4de;
        width: 100%;
        height: 60px;
    }

    .segments {
        margin-bottom: 10px;
        display: flex;
        align-items: center;
    }

    .select-segment {
        background-color: #006cff;
        display: flex;
        align-items: center;
        border-radius: 3px;
        padding: 3px;
        padding-right: 10px;
        margin-right: 7px;
        width: fit-content;
        margin-top: 5px;
    }

    .select-segment-text {
        color: white;
    }

    .closeIcon {
        color: white !important;
        padding-right: 3px;
        font-size: 20px;

        &:hover {
            cursor: pointer;
        }
    }

    .last-session-data {
        max-width: 200px;
        color: #516173;
        font-weight: 500;
        font-size: 14px;
        line-height: 20px;
    }

    .user-segment-avatar {
        height: 80px;
        width: 80px;
        margin-left: 60px;
        margin-top: -30px;
        display: flex;
        align-items: center;
        font-size: 16px;
        background: #ffa800;
        border-radius: 50%;
        margin-right: 10px;
    }

    .md-highlight-text {
        color: white;
        font-size: larger;
        font-weight: bold;
    }

    .detail-body {
        margin-left: 30px;
        margin-right: 30px;
        margin-bottom: 50px;
        margin-top: 40px;

        .story-menu-content {
            border: none;
            background: none;
            box-shadow: none;

            .delete-user {
                cursor: pointer;

                &:hover {
                    color: #008aff;
                }
            }
        }

        .page-right {
            padding-right: 93px;
        }
    }

    .segment-user {
        color: #22272d;
        font-weight: 500;
        font-size: 16px;
        margin-left: 15px;
        line-height: 23px;
    }

    .user-data {
        height: 23px;
        width: 100%;
        display: flex;
        align-items: center;
        margin-bottom: 20px;
    }

    .material-icons {
        color: #ffa800;
    }

    .data-box {
        border: 1px solid #dbe1e8;
        border-radius: 4px;
        -webkit-box-shadow: 0 1px 1px 0 rgb(0 0 0 / 13%);
        box-shadow: 0 1px 1px 0 rgb(0 0 0 / 13%);
        padding: 25px;
        display: grid;
        width: 100%;
        min-width: 500px;
        height: 118px;
    }

    .last-session-info {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }

    .dark-mode .header-color {
        background: #1c1c1c;
    }
}

.dark-mode #visitor-detail {
    background-color: #343441 !important;

    .user-name {
        color: #bab5b5;
    }

    .segment-user {
        color: #bab5b5;
    }

    .last-session-data {
        color: #bab5b5;
    }
}

.dark-mode #visitorChatList #visitor-history-list .item .participant {
    color: #bab5b5;
}

#delete-user-modal {
    .ant-modal-footer {
        border: none;
    }

    .delete-user-modal-message {
        font-size: 16px;
        line-height: 20px;
        color: #516173;
    }

    .ant-modal-header {
        display: flex;
        justify-content: center;
    }
}

.dark-mode #visitor-detail {
    .head-color {
        background-color: #584a66;
    }

    .md-theme-default {
        background: transparent !important;
    }

    .ant-btn {
        background-color: transparent !important;
    }
}
</style>
